import { render, staticRenderFns } from "./ProgresBarCourse.vue?vue&type=template&id=52b65834"
import script from "./ProgresBarCourse.vue?vue&type=script&lang=js"
export * from "./ProgresBarCourse.vue?vue&type=script&lang=js"
import style0 from "./ProgresBarCourse.vue?vue&type=style&index=0&id=52b65834&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports